import { onlyDigits } from '@/shared/lib/format';

const REPEATED_SEQUENCES = new Set([
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
]);

/** Valida dígitos verificadores de CPF (módulo 11) — replica legacy/fixe-link-2 `public/js/valida_cpf.js`. */
export function isValidCpf(value: string): boolean {
  const cpf = onlyDigits(value);
  if (cpf.length !== 11 || REPEATED_SEQUENCES.has(cpf)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += Number(cpf.charAt(i)) * (10 - i);
  let checkDigit = 11 - (sum % 11);
  if (checkDigit >= 10) checkDigit = 0;
  if (checkDigit !== Number(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) sum += Number(cpf.charAt(i)) * (11 - i);
  checkDigit = 11 - (sum % 11);
  if (checkDigit >= 10) checkDigit = 0;
  return checkDigit === Number(cpf.charAt(10));
}
